import request from '@/utils/request'

//文章列表
export function articleList(data) {
  return request({
    url: `/Member/GetMemberArticleList`,
    method: 'post',
    data
  })
}

//文章详情
export function articleDetail(data) {
  return request({
    url: `/Home/GetArticleDetail`,
    method: 'post',
    data
  })
}

//推荐文章列表
export function recommendArticle(data) {
  return request({
    url: `/Home/GetRecArticleList`,
    method: 'post',
    data
  })
}

//获取文章评论
export function articleComment(data) {
  return request({
    url: `/Home/GetArticleComment`,
    method: 'post',
    data
  })
}


//点赞文章
export function createArticleLike(data) {
  return request({
    url: `/Home/CreateArticleLike`,
    method: 'post',
    data
  })
}

//取消点赞文章
export function cancelArticleLike(data) {
  return request({
    url: `/Home/CancelArticleLike`,
    method: 'post',
    data
  })
}

//收藏文章
export function addCollections(data) {
  return request({
    url: `/Home/AddCollections`,
    method: 'post',
    data
  })
}

//取消收藏文章
export function deleteCollections(data) {
  return request({
    url: `/Home/DeleteCollections`,
    method: 'post',
    data
  })
}

//点赞评论
export function createArticleCommentLike(data) {
  return request({
    url: `/Home/CreateArticleCommentLike`,
    method: 'post',
    data
  })
}

//取消点赞评论
export function cancelArticleCommentLike(data) {
  return request({
    url: `/Home/CancelArticleCommentLike`,
    method: 'post',
    data
  })
}

//点击确认按钮发送
export function createArticleComment(data) {
  return request({
    url: `/Home/CreateArticleComment`,
    method: 'post',
    data
  })
}